module.exports = __webpack_public_path__ + "assets/fonts/iconfont.50cd2c6e.ttf";